import { createContext } from 'react';
import { FeatureFlagName } from '@/utils/featureFlags';

interface FeatureFlagsContextType {
  isFeatureEnabled: (featureName: FeatureFlagName) => boolean;
}

export const FeatureFlagsContext = createContext<FeatureFlagsContextType | undefined>(undefined);
